export default __webpack_public_path__ + "media/images/react_icons/fb-with-frame-0979b5f493eb08da7be58fd79b9eae21.svg";